import MediaEmptyState from '@/Pages/BrandKit/components/MediaCard/MediaEmptyState';
import { BackgroundImageEmptyStateProps } from '@/Pages/BrandKit/types';

export default function BackgroundImageEmptyState({ brandKitId }: BackgroundImageEmptyStateProps): JSX.Element {
  const ctaHref = brandKitId ? `/brand-kit/${brandKitId}/edit` : '/brand-kit';

  return (
    <MediaEmptyState
      icon="IconPhoto"
      title="No images added"
      description="Add images to your brand kit to reuse them across assets."
      ctaLabel="Add Images"
      ctaHref={ctaHref}
    />
  );
}
